import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Zap, Calendar, MapPin, User } from "lucide-react";

const TABS = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/stili", label: "Stili", icon: Zap },
  { to: "/prenota", label: "Prenota", icon: Calendar },
  { to: "/studio", label: "Studio", icon: MapPin },
  { to: "/profilo", label: "Profilo", icon: User },
];

export default function Layout({ children }) {
  const location = useLocation();
  return (
    <div className="min-h-screen bg-mo-surface text-mo-ink">
      {/* Top bar */}
      <header className="sticky top-0 z-40 border-b border-mo-line bg-mo-surface/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-3.5">
          <NavLink to="/" className="group flex items-center gap-2" data-testid="brand-logo">
            <span className="font-display text-2xl font-bold tracking-wide text-mo-ink">
              Mörphösy
            </span>
            <span className="hidden font-body text-[10px] font-bold uppercase tracking-[0.3em] text-mo-brand sm:inline">
              Tattoo Studio
            </span>
          </NavLink>
          <nav className="hidden items-center gap-1 md:flex">
            {TABS.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={`nav-${t.label.toLowerCase()}`}
                className={({ isActive }) =>
                  "flex items-center gap-2 rounded-full px-4 py-2 font-body text-[13px] font-bold transition-colors " +
                  (isActive ? "bg-mo-brand text-mo-onbrand" : "text-mo-muted hover:text-mo-ink")
                }
              >
                <t.icon className="h-4 w-4" />
                {t.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main key={location.pathname} className="mx-auto max-w-5xl pb-24 md:pb-10">
        {children}
      </main>

      {/* Bottom tab bar (mobile) */}
      <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-mo-line bg-mo-surface2/95 backdrop-blur-xl md:hidden">
        <div className="mx-auto flex max-w-lg items-stretch justify-between px-2">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={`tab-${t.label.toLowerCase()}`}
              className={({ isActive }) =>
                "flex flex-1 flex-col items-center gap-1 py-2.5 font-body text-[10px] font-semibold transition-colors " +
                (isActive ? "text-mo-brand" : "text-mo-muted")
              }
            >
              <t.icon className="h-5 w-5" />
              {t.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
